import * as React from 'react';
/**
 * A [React Context](https://reactjs.org/docs/context.html) providing access to the [SchedulerEditSlot]({% slug api_scheduler_schedulereditslot %}) `props`.
 *
 * For more information, refer to the [Items Context]({% slug state-update_items_scheduler %}) article.
 */
export var SchedulerEditSlotPropsContext = React.createContext([null]);
/**
 * A custom [React Hook](https://reactjs.org/docs/hooks-intro.html) providing access to the [SchedulerEditSlot]({% slug api_scheduler_schedulereditslot %}) `props`.
 *
 * For more information, refer to the [Items Context]({% slug state-update_items_scheduler %}) article.
 * @returns
 */
export var useSchedulerEditSlotPropsContext = function () { return React.useContext(SchedulerEditSlotPropsContext); };
SchedulerEditSlotPropsContext.displayName = 'SchedulerEditSlotPropsContext';
/**
 * A [React Context](https://reactjs.org/docs/context.html) providing access to the [SchedulerEditSlot]({% slug api_scheduler_schedulereditslot %}) internal `formItem` state.
 *
 * For more information, refer to the [Slots Context]({% slug state-update_slots_scheduler %}) article.
 */
export var SchedulerEditSlotFormItemContext = React.createContext([null]);
/**
 * A custom [React Hook](https://reactjs.org/docs/hooks-intro.html) providing access to the [SchedulerEditSlot]({% slug api_scheduler_schedulereditslot %}) internal `formItem` state.
 *
 * For more information, refer to the [Slots Context]({% slug state-update_slots_scheduler %}) article.
 * @returns
 */
export var useSchedulerEditSlotFormItemContext = function () { return React.useContext(SchedulerEditSlotFormItemContext); };
SchedulerEditSlotFormItemContext.displayName = 'SchedulerEditSlotFormItemContext';
/** @hidden */
export var SchedulerEditSlotContext = function (_a) {
    var props = _a.props, form = _a.form, children = _a.children;
    return (React.createElement(SchedulerEditSlotPropsContext.Provider, { value: props },
        React.createElement(SchedulerEditSlotFormItemContext.Provider, { value: form }, children)));
};
//# sourceMappingURL=SchedulerEditSlotContext.js.map